import { get, post } from "./api"

export async function updateKidData(programSessionId, kidId, attendanceValue, notesValue) {
  try {
    return await post('coach/updateKidData', { programSessionId, kidId, attendanceValue, notesValue })
  } catch (error) {
    return { error }
  }
}

export async function getCoachDashboard() {
  try {
    return await get('coach/coachDashboard')
  } catch (error) {
    return { error }
  }
}
